var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { "data-grm-comp": "RoomCBTLogUserResult" } }, [
    _c("table", [
      _vm._m(0),
      _vm._m(1),
      _c(
        "tbody",
        _vm._l(
          _vm.getCBTLogUserQuestionList(_vm.roomCbtUser),
          function (question, i) {
            return _c("tr", { key: question.questionId }, [
              _c("td", [_vm._v(_vm._s(i + 1))]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    question.questionType === "CHOICE" ? "객관식" : "주관식"
                  )
                ),
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-x-0.5" },
                  _vm._l(question.answerList, function (answer, i) {
                    return _c(
                      "span",
                      {
                        key: answer.answerId,
                        staticClass:
                          "w-4 h-4 rounded-full text-xs flex justify-center items-center",
                        class: answer.correct ? "bg-black" : "border",
                      },
                      [_vm._v(_vm._s(i + 1))]
                    )
                  }),
                  0
                ),
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-x-0.5" },
                  _vm._l(
                    _vm.cbtLog.cbt.questionList[i]?.answerList,
                    function (answer, i) {
                      return _c(
                        "span",
                        {
                          key: answer.answerId,
                          staticClass:
                            "w-4 h-4 rounded-full text-xs flex justify-center items-center",
                          class: answer.correct ? "bg-black" : "border",
                        },
                        [_vm._v(_vm._s(i + 1))]
                      )
                    }
                  ),
                  0
                ),
              ]),
              _c("td", [_vm._v(_vm._s(question.isCorrect ? "O" : "X"))]),
              _c("td", [_vm._v(_vm._s(question.questionScore))]),
            ])
          }
        ),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "2" } }),
      _c("col", { attrs: { width: "10" } }),
      _c("col", { attrs: { width: "10" } }),
      _c("col", { attrs: { width: "2" } }),
      _c("col", { attrs: { width: "2" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("번호")]),
        _c("th", [_vm._v("유형")]),
        _c("th", [_vm._v("제출 답안")]),
        _c("th", [_vm._v("정답")]),
        _c("th", [_vm._v("결과")]),
        _c("th", [_vm._v("배점")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }